<ion-content class="modal-border">
  <ion-header
    ><ion-toolbar
      ><ion-row>
        <ion-title class="ion-padding">Assign users</ion-title>
        <ion-buttons>
          <ion-button (click)="dismissModal()" size="large" slot="end">
            <ion-icon name="close"></ion-icon>
          </ion-button> </ion-buttons></ion-row
    ></ion-toolbar>
  </ion-header>

  <div class="ion-padding">
    <div *ngIf="loadingDone == false">
      <ion-label>Loading in progress, please wait...</ion-label>
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </div>

    <div *ngIf="loadingDone == true">
      <ion-grid>
        <ion-row>
          <ion-col size="10">
            <ion-item>
              <ion-label position="stacked"
                >Type to search users by Name, Job title, ID, etc
              </ion-label>
              <ion-input
                [(ngModel)]="peopleSearchText"
                (keyup.enter)="onSubmit()"
              ></ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="2">
            <ion-button (click)="onSubmit()">
              <ion-label>Search</ion-label>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-grid>
        <ion-row>
          <ion-col size="2">
            <ion-item>
              <ion-label
                >People selected : {{peopleSelectedList.length}}</ion-label
              >
            </ion-item>
          </ion-col>
          <ion-col size="3">
            <ion-item>
              <ion-label>Show Selected Users</ion-label>
              <ion-toggle
                [ngModel]="showSelected"
                (ngModelChange)="ShowSelected(!showSelected)"
              ></ion-toggle>
            </ion-item>
          </ion-col>
          <ion-col size="3"> </ion-col>
          <ion-col size="2">
            <ion-button (click)="deselectAll()" class="menuitem-ion-button"
              >Deselect All</ion-button
            >
          </ion-col>
          <ion-col size="2">
            <ion-button (click)="selectAll()" class="menuitem-ion-button"
              >Select All</ion-button
            >
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-grid>
        <div *ngIf="!showSelected">
          <ion-row>
            <div *ngFor="let people of peopleList;">
              <ion-col class="grid-block" (click)="selectPerson($event,people)">
                <div [ngClass]="{'selected': inSelectedList(people) == true}">
                  <div *ngIf="people?.Picture_ContentGUID != ''">
                    <img
                      class="media-thumbnail-img border-radius"
                      style="
                        padding-top: 0px;
                        padding-right: 5px;
                        padding-left: 5px;
                        padding-bottom: 5px;
                        padding-top: 5px;
                      "
                      (error)="globals.onThumbnailError($event,'user_blank.jpg')"
                      src="{{globals.GetXRSCustomContentURL() + 'Thumbnails/' + people?.Picture_ContentGUID + '.jpg'}}"
                    />
                  </div>

                  <div
                    style="
                      padding: 5px;
                      padding-top: 0px;
                      padding-bottom: 5px;
                      width: 200px;
                      height: 75px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    <ion-label>{{people.FirstName}}</ion-label><br />
                    <ion-label>{{people.Surname}}</ion-label><br />
                    <ion-label>{{people.CompanyNumber}}</ion-label><br />
                    <ion-label>{{people.JobTitle}}</ion-label>
                  </div>
                </div>
              </ion-col>
            </div>
          </ion-row>
        </div>

        <div *ngIf="showSelected">
          <ion-row>
            <div *ngFor="let people of peopleSelectedList;">
              <ion-col class="grid-block" (click)="selectPerson($event,people)">
                <div
                  (click)="people.UserAssigned = !people.UserAssigned;"
                  [ngClass]="{'selected': inSelectedList(people) == true}"
                >
                  <div *ngIf="people?.Picture_ContentGUID != ''">
                    <img
                      class="media-thumbnail-img border-radius"
                      style="
                        padding-top: 0px;
                        padding-right: 5px;
                        padding-left: 5px;
                        padding-bottom: 5px;
                        padding-top: 5px;
                      "
                      (error)="globals.onThumbnailError($event,'user_blank.jpg')"
                      src="{{globals.GetXRSCustomContentURL() + 'Thumbnails/' + people?.Picture_ContentGUID + '.jpg'}}"
                    />
                  </div>

                  <div
                    style="
                      padding: 5px;
                      padding-top: 0px;
                      padding-bottom: 5px;
                      width: 200px;
                      height: 75px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    <ion-label>{{people.FirstName}}</ion-label><br />
                    <ion-label>{{people.Surname}}</ion-label><br />
                    <ion-label>{{people.CompanyNumber}}</ion-label><br />
                    <ion-label>{{people.JobTitle}}</ion-label>
                  </div>
                </div>
              </ion-col>
            </div>
          </ion-row>
        </div>
      </ion-grid>

      <ion-row>
        <ion-col class="modal-ion-col-bottom-buttons" style="left: 0">
          <ion-button
            (click)="onCloseUpload()"
            class="menuitem-ion-button"
            style="width: 110% !important; left: 0"
            >Close</ion-button
          >
        </ion-col>
      </ion-row>
    </div>
  </div>
</ion-content>
